const uuid = require('uuid');
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';

const _ = {
    find:       require('lodash/find'),
    findIndex:  require('lodash/findIndex'),
    filter:     require('lodash/filter'),
    forEach:    require('lodash/forEach'),
    get:        require('lodash/get'),
    isEqual:    require('lodash/isEqual'),
    map:        require('lodash/map'),
};

// required for react-mzl
function debugLog() {
    if (GlobalConfig.DebugMode || GlobalConfig.DevMode) {
        console.log.apply(console,arguments);
    }
}
global.debugLog = debugLog;

const RichTextEditor = require('@muzzylane/react-mzl/dist/RichTextEditor');

const ShortCourseConstants = require('../../../../app/shared/ShortCourseConstants');
const ShortCourseUtil = require('../../../../app/shared/ShortCourseUtil');

const AssetUtil = require('../../util/asset');
const ReactMzlUtils = require('../../util/ReactMzlUtils');

const SignInStore = require('../../stores/SignInStore');

const ShortCourseEditorActions = require('../../actions/ShortCourseEditorActions');
const ShortCourseEditorStore = require('../../stores/ShortCourseEditorStore');
const ShortCourseStore = require('../../stores/ShortCourseStore');

import ErrorBox from '../common/ErrorBox';
import ConfirmModal from '../modal/ConfirmModal';
import AccessibleIcon from '../common/AccessibleIcon';
import SingleAssetInput from '../common/SingleAssetInput';

import ShortCourseFlowDiagram from './ShortCourseFlowDiagram';
import ShortCourseNodeEditor from './ShortCourseNodeEditor';
import ShortCourseSettingsEditor from './ShortCourseSettingsEditor';
import ContentUpdater from './ContentUpdater';

const ReviewCommentEditor = require('./sidebar/ReviewCommentEditor');
// const HelpSidebar = require('./sidebar/HelpSidebar');
const ValidationSidebar = require('./sidebar/ValidationSidebar');
const SearchSidebar = require('./sidebar/SearchSidebar');
const GotoCommentIcon = require('./sidebar/GotoCommentIcon');

const ESM = {
    Collapsed: 'Collapsed',
    Comments: 'Comments',
    Help: 'Help',
    Validation: 'Validation',
    Search: 'Search',
}

const EditShortCoursePropTypes = {
    shortCourse: PropTypes.object.isRequired,
    editedDoc: PropTypes.object.isRequired,
    errorLines: PropTypes.array,
    selectedNode: PropTypes.object,
    projects: PropTypes.object.isRequired,
    activities: PropTypes.array.isRequired,
    templates: PropTypes.object.isRequired,
    onPreviewActivity: PropTypes.func.isRequired,
    courseCommentInfo: PropTypes.object,
    refreshComments: PropTypes.func,
    commentAction: PropTypes.func,

};

const EditShortCourseDefaultProps = {
    errorLines: [],
    selectedNode: null,
};

class EditShortCourse extends React.Component {
    constructor(props) {
        super(props);
        const userInfo = SignInStore.getState().userInfo;
        let userHash = userInfo.hash;
        
        this.app = ReactMzlUtils.getAppForSharedComponents({ course_hash: props.shortCourse.hash, getDoc: ()=>{ return props.editedDoc; } }); // for react-mzl

        var pixels_per_rem = getComputedStyle(document.documentElement).fontSize;
        if (pixels_per_rem.indexOf('px') > 0) {
            pixels_per_rem = Number(pixels_per_rem.split('px')[0]);
        }
        else {
            debugLog("using fallback pixels_per_rem");
            pixels_per_rem = 10;
        }

        let enableCommentSidebar = props.courseCommentInfo ? true : false;
        let allCommentCount = 0;
        let userCommentCount = 0;
        if (enableCommentSidebar) {
            allCommentCount = props.courseCommentInfo.shortCourseComments.length;
            let userComments = _.filter(props.courseCommentInfo,{assignee_id:userHash});
            userCommentCount = userComments.length;
        }
        
        let validationCounts = this.getValidationCounts();
        let validationErrorCount = validationCounts.validationErrorCount;
        let validationWarningCount =  validationCounts.validationWarningCount;
        let expandingSidebarMode = ESM.Collapsed
        const comment_id = ShortCourseStore.getAndClearEditGotoComment(this.props.shortCourse.id);
        if (comment_id) {
            expandingSidebarMode = ESM.Comments;
            setTimeout(()=>{
                if (this._commentEditor && this._commentEditor.goToCommentIdLocation(comment_id)) {
                    // done
                }
                else {
                    // fallback
                    ShortCourseEditorActions.goToLocation({
                        type: ShortCourseConstants.NAV_TYPES.Comment,
                        id: comment_id
                    });
                }
            },1);
        }

        this.state = {
            childModalParams: null,
            selectedNode: null,
            modalState: {
                child: false,
                rich_text_editor: false,
            },

            // sidebar state
            expandingSidebarMode,
            editorPixelWidth: screen.width,
            sidebarExpandedWidth: Math.round(screen.width * 0.20),
            sidebarCollapsedWidth: pixels_per_rem * 5,
            sidebarKey: 1,
            userHash,
            validationErrorCount, validationWarningCount,
            enableCommentSidebar, allCommentCount, userCommentCount,
        };
        
        this.unsubscribes = [
            ShortCourseEditorStore.listen(this.onEditorStoreChange),
        ];
    }
    
    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions);
        const comment_refresh_ms = 5*60*1000;
        this.commentRefresher = window.setInterval(this.props.refreshComments, comment_refresh_ms); // TODO should this be in componentDidMount?
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
        window.clearInterval(this.commentRefresher);
        this.unsubscribes.forEach(u => u());
    }
    
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.courseCommentInfo !== nextProps.courseCommentInfo) {
            let enableCommentSidebar = nextProps.courseCommentInfo ? true : false;
            let allCommentCount = 0;
            let userCommentCount = 0;
            if (enableCommentSidebar) {
                allCommentCount = nextProps.courseCommentInfo.shortCourseComments.length;
                let userComments = _.filter(nextProps.courseCommentInfo,{assignee_id:this.state.userHash});
                userCommentCount = userComments.length;
            }
            this.setState({enableCommentSidebar,allCommentCount,userCommentCount});
        }
    }

    
    getDataForValidation=()=>{
        return {
            hash: this.props.shortCourse.hash,
            shortCourse: {
                doc: this.props.editedDoc,
            },
        };
    }
    
    getValidationCounts=()=>{
        // avoid taking too much cpu validating too often
        if (this.state) {
            var now = Date.now();
            var lastValidation = this.lastValidationCheck;
            if (lastValidation && (now - lastValidation < 15000)) {
                return {
                    validationErrorCount: this.state.validationErrorCount || 0,
                    validationWarningCount: this.state.validationWarningCount || 0,
                };
            }
        }
        
        var validation = ShortCourseUtil.validateShortCourse(this.getDataForValidation());
        return {
            validationErrorCount: validation.errors.length,
            validationWarningCount: validation.warnings.length,
        };
    }
    
    onEditorStoreChange=(storeState)=>{
        if (storeState.action) {
            switch(storeState.action.name) {
                case 'goToLocation':
                {
                     let navObject = storeState.currentNav;
                     let rich_text_id, coach_script_id,action_index;
                     switch(navObject.type) {
                        case ShortCourseConstants.NAV_TYPES.CoachScript:
                            rich_text_id = navObject.rich_text_id;
                            action_index = navObject.action_index;
                            coach_script_id = navObject.id;
                            break;
                            
                         case ShortCourseConstants.NAV_TYPES.RichText:
                            rich_text_id = navObject.id;
                            break;
                    }
                    if (rich_text_id && this.props.editedDoc) {
                        let richTextQuery = {id:rich_text_id};
                        let richTextEntry = _.find(this.props.editedDoc.client_content.rich_texts,richTextQuery);
                        if (richTextEntry ) {
                            let editableTitle = false;
                            if (!richTextEntry.specialPurpose) {
                                editableTitle = true;
                            }
                            let onDoneCallback = ()=>{
                                if (coach_script_id) {
                                    // open the coach script editor after we close rich text editor modal
                                    let navObject = {
                                        type: ShortCourseConstants.NAV_TYPES.CoachScript,
                                        id: coach_script_id,
                                        action_index: action_index,
                                    };
                                    ShortCourseEditorActions.goToLocation(navObject);
                                }
                            }
                            this.setRichTextEditorModalState(richTextQuery, richTextEntry.displayName, editableTitle, onDoneCallback, coach_script_id);
                        }
                    }
                    break;
                }
            }
        }
        
        let validationCounts = this.getValidationCounts();
        let validationErrorCount = validationCounts.validationErrorCount;
        let validationWarningCount =  validationCounts.validationWarningCount;
        
        this.setState({validationErrorCount,validationWarningCount});
    }

    doGetRichText = () => {
        let richTextQuery = this.state.modalState['rich_text_editor'];
        let richTextEntry = _.find(this.props.editedDoc.client_content.rich_texts,richTextQuery);
        let richText;
        if (richTextEntry) {
            richText = richTextEntry.rich_text || "";
        }
        else {
            richText = "";
        }
        return { richText };
    }
    
    doGetRichTextSnippets=()=>{
        let id = this.state.modalState && this.state.modalState.rich_text_editor_coach_script_id;
        if (!id) {
            return null;
        }
        const coachEntry = _.find(ShortCourseConstants.COACH_TEXTS,{id});
        if (!coachEntry) {
            console.log(`no coachEntry for ${id}`);
            return null;
        }
        let variableSnippets = coachEntry.variableSnippets || [];
        variableSnippets = variableSnippets.slice();
        if (this.props.editedDoc.client_content.phraseData) {
            _.forEach(this.props.editedDoc.client_content.phraseData.phraseSets,(entry)=>{
                if (entry.phrases.length) {
                    let snippetId = ShortCourseConstants.PHRASE_VARIABLE_PREFIX + entry.variableSuffix;
                    variableSnippets.push({
                        id: snippetId,
                        displayName: `Coach Phrase:${entry.variableSuffix}`,
                        snippet: `{${snippetId}}`,
                    });
                }
            });
        }
        if (!variableSnippets.length) {
            return null;
        }
        return variableSnippets;
    }
    
    getRichTextId=()=>{
        let richTextQuery = this.state.modalState['rich_text_editor'];
        let richTextEntry = _.find(this.props.editedDoc.client_content.rich_texts,richTextQuery);
        if (richTextEntry) {
            return richTextEntry.id;
        }
        return '';
    }
    
    onRichTextTitleChange=(e)=>{
        let title = e.target.value;
        let rich_text_id = this.getRichTextId();
        if (!rich_text_id) {
            return;
        }
        this.setState({ 
            modalState: { ...this.state.modalState, 
                rich_text_editor_title: title
            },
        },()=>{
            ShortCourseEditorActions.setRichTextTitle(uuid.v4(), rich_text_id, title);
        });
    }
    
    getRichTextNavLoc=()=>{
        let richTextQuery = this.state.modalState['rich_text_editor'];
        let richTextEntry = _.find(this.props.editedDoc.client_content.rich_texts,richTextQuery);
        if (!richTextEntry) {
            return {type:ShortCourseConstants.NAV_TYPES.Settings}; // punt
        }
        const rich_text_id = richTextEntry.id;
        
        if (richTextEntry.coach_script_id) {
            let coachEntry = _.find(this.props.editedDoc.client_content.coach_scripts,{id:richTextEntry.coach_script_id});
            if (coachEntry) {
                let action_index = _.findIndex(coachEntry.actions,{rich_text_id});
                return {
                    type: ShortCourseConstants.NAV_TYPES.CoachScript,
                    id: richTextEntry.coach_script_id,
                    rich_text_id,
                    action_index
                }
            }
        }
        return {
            type: ShortCourseConstants.NAV_TYPES.RichText,
            id: rich_text_id,
        };
    }
    
    doApplyRichTextChanges = (changes,keepOpen) => {
        // console.log("doApplyRichTextChanges changes: " + JSON.stringify(changes));
        let rich_text_id = this.getRichTextId();
        if (rich_text_id) {
            if (changes.richText) {
                ShortCourseEditorActions.setRichText(uuid.v4(), rich_text_id, changes.richText);
            }
            if (!keepOpen) {
                this.closeRichTextEditor();
            }
        }
        else {
            console.log("no rich text id?");
            this.closeRichTextEditor();
        }
    }
    
    editRichText = (richTextQuery, title, onDoneCallback,coach_script_id) => {
        let richTextEntry = _.find(this.props.editedDoc.client_content.rich_texts,richTextQuery);
        let editableTitle = false;
        if (!richTextEntry.specialPurpose) {
            editableTitle = true;
        }
        if (this.props.editedDoc) {
            this.setRichTextEditorModalState(richTextQuery, title, editableTitle, onDoneCallback, coach_script_id);
        }
    }
    
    closeRichTextEditor = () => {
        this.setRichTextEditorModalState(false);
    }

    addSkillNode = () => {
        ShortCourseEditorActions.addSkillNode(uuid.v4());
    }
    
    addCapstoneNode = () => {
        ShortCourseEditorActions.addSkillNode(uuid.v4(),true);
    }
    
    setRichTextEditorModalState = (richTextQuery, title, editableTitle, onDoneCallback, coach_script_id) => {
        let close_callback = this.state.modalState.close_callback;
        this.setState({ 
            modalState: { ...this.state.modalState, 
                rich_text_editor: richTextQuery,
                rich_text_editor_title: title,
                rich_text_editor_title_editable: editableTitle,
                rich_text_editor_coach_script_id: coach_script_id,
                close_callback: onDoneCallback,
            },
        },()=>{
            if (close_callback) {
                close_callback();
            }
        });
    }

    openChildModal = (params) => {
        this.setState({ 
            modalState: { ...this.state.modalState, child: true },
            childModalParams: params,
        });
    }
    
    confirmChildModal = (confirmData) => {
        if (this.state.childModalParams && this.state.childModalParams.confirmHandler) {
            this.state.childModalParams.confirmHandler(confirmData);
        }

        this.closeChildModal();
    }
    
    cancelChildModal = (cancelData) => {
        if (this.state.childModalParams && this.state.childModalParams.cancelHandler) {
            this.state.childModalParams.cancelHandler(cancelData);
        }

        this.closeChildModal();
    }

    closeChildModal = () => {
        let childCloseHandler = this.state.childModalParams && this.state.closeHandler; // in case the child wants to do something when the modal is closed
        this.setState({ 
            modalState: { ...this.state.modalState, child: false },
            childModalParams: null,
        }, () => {            
            if (childCloseHandler) {
                childCloseHandler();
            }
        });
    }
    
    updateDimensions=()=>{
        var elem = ReactDOM.findDOMNode(this.refs.contentarea);
        if (elem) {
            var w = elem.offsetWidth;
            if ((w > 100) && (w != this.state.editorPixelWidth)) {
                var sidebar_fraction = this.state.editorPixelWidth ? (this.state.sidebarExpandedWidth / this.state.editorPixelWidth) : 0.2;
                var sw = Math.round(w * sidebar_fraction);
                this.setState({
                    editorPixelWidth: w,
                    sidebarExpandedWidth: sw,
                })
            }
        }
    }
    
    //onScrollToNav=(navLoc)=>{
    //    this.handleNav(navLoc);
    //}
    
    addCommentAtLoc=(navLoc)=>{
        ShortCourseEditorActions.setCurrentNavLoc(navLoc);
        window.setTimeout(()=>{
            this.setState({
                expandingSidebarMode: ESM.Comments, 
            },()=>{
                if (this._commentEditor) {
                    this._commentEditor.openNewCommentEditor();
                }
            });
        },30);
    }

    /*handleNav=(navObject)=>{
        // handle any nav changes that aren't already part of ShortCourseEditorStore state
        switch(navObject.type) {
            //case ShortCourseConstants.NAV_TYPES.Settings:
            //case ShortCourseConstants.NAV_TYPES.Node:
            // case ShortCourseConstants.NAV_TYPES.RichText:
            //case ShortCourseConstants.NAV_TYPES.CoachScript:
            case ShortCourseConstants.NAV_TYPES.Comment:
                this.setState({
                    expandingSidebarMode: ESM.Comments, 
                });
                break;
        }
    }*/ // handleNav

    toggleCommentSidebar=()=>{
        this.setState({ expandingSidebarMode: (this.state.expandingSidebarMode === ESM.Comments) ? ESM.Collapsed : ESM.Comments});
    }

//    toggleHelpSidebar=()=>{
//        this.setState({ expandingSidebarMode: (this.state.expandingSidebarMode === ESM.Help) ? ESM.Collapsed : ESM.Help});
//    }

    toggleValidationSidebar=()=>{
        this.setState({ expandingSidebarMode: (this.state.expandingSidebarMode === ESM.Validation) ? ESM.Collapsed : ESM.Validation});
    }
    
    toggleSearchSidebar=()=>{
        this.setState({ expandingSidebarMode: (this.state.expandingSidebarMode === ESM.Search) ? ESM.Collapsed : ESM.Search});
    }
    
    /*onScrollToComment=(comment_id)=>{
        if (this.state.expandingSidebarMode !== ESM.Comments) {
            this.setState({
                expandingSidebarMode: ESM.Comments, 
            });
        }
    }*/
    
//    handleSideDividerDragStart=(evt)=>{
//        // console.log("started dragging");
//    }
    
    handleSideDividerDrag=(evt)=>{
        if (evt.movementX) {
            var w = this.state.sidebarExpandedWidth - evt.movementX;
            var minW = Math.round(this.state.editorPixelWidth * 0.1);
            var maxW = Math.round(this.state.editorPixelWidth * 0.5);
            w = Math.min(maxW,Math.max(minW,w));
            this.setState({sidebarExpandedWidth: w});
        }
    }
    
    handleSideDividerDragStop=(/*evt*/)=>{
        // console.log("stopped dragging");
        window.setTimeout(()=>{
            this.setState({sidebarKey: this.state.sidebarKey+1}); // fix for drag bar being stuck in original position
        },1);
    }
    
    getCommentProps=()=>{
        return {
            hasOpenComment: this.hasOpenComment,
            selectedCommentIsInNavLoc: this.selectedCommentIsInNavLoc,
            canAddComment: this.canAddComment(),
            showingComments: (this.state.expandingSidebarMode === ESM.Comments),
            addComment: this.addCommentAtLoc,
            showCommentsAtLoc: this.showCommentsAtLoc,
        };
    }

    renderShortCourseFlowEditor=()=>{
		// if we want no editor on the right and full use of the display area
		// { this.props.selectedNode ? "short-course-flow-editor" : "short-course-flow-editor full-width" } 
        
        var noCapstone = false;
        if (this.props.editedDoc && this.props.editedDoc.nodes) {
            let capstone = _.find(this.props.editedDoc.nodes,{capstone:true});
            if (!capstone) {
                noCapstone = true;
            }
                
        }
        let bgImgSrc = _.get(this.props.editedDoc.client_content,`background_img`);
        if (bgImgSrc) {
            bgImgSrc = bgImgSrc.replace(/^\$ASSET_PREFIX/, GlobalConfig.AssetStoreUrl);
        }
        
        let editingComment = false;
        if (this._commentEditor) {
            editingComment = this._commentEditor.isEditingComment();
        }
        
        const commentProps = this.getCommentProps();
        
        return (
            <div className="flow-editor-and-right-panel-editor">
                <div className="short-course-flow-editor">
                    {this.props.editedDoc ? 
                    <ShortCourseFlowDiagram editedDoc={this.props.editedDoc}/>
                    : null }
                    <div className="control-icons">
                        <button className="create-node-button" title="create new skill node" onClick={this.addSkillNode}>
                            <AccessibleIcon className="fa fa-plus-circle" label="create new skill node">
                                <label className="button-subtitle">Create New Skill Node</label>
                            </AccessibleIcon>
                        </button>
                        {noCapstone ? 
                        <button className="create-node-button" title="create capstone node" onClick={this.addCapstoneNode}>
                            <AccessibleIcon className="fa fa-plus-circle" label="create capstone node">
                                <label className="button-subtitle">Create Capstone Node</label>
                            </AccessibleIcon>
                        </button>
                        : null }
                        <div className="bg-tile">
                            {bgImgSrc ? <img src={bgImgSrc} /> : null }
                            {bgImgSrc ? 
                                <button className="remove-bg-button" title="remove course background" disabled={this.props.reviewMode} onClick={ this.props.onRemoveImage }>
                                    <AccessibleIcon className="fa fa-trash" label="remove course background">
                                    </AccessibleIcon>
                                </button>
                             : null }
                            <SingleAssetInput
                                buttonOnly
                                additionalClasses="img-upload-btn"
                                browseText={bgImgSrc ? "Replace Background Image" : "Upload Background Image"}
                                assetType="image"
                                assetRole="normal"
                                accept="image/*"
                                onChange={this.props.onUpdateImage}
                                onError={this.props.onUpdateImageError}
                                validateAssetType={AssetUtil.validateImageMimeType}
                                disabled={!!this.props.imageUpdateActionID || this.props.reviewMode}
                            />
                        </div>
                    </div>
                </div>
                { this.props.selectedNode ?
                <div className="short-course-node-editor">
                    <ShortCourseNodeEditor node={this.props.selectedNode} projects={this.props.projects} activities={this.props.activities} templates={this.props.templates} 
                        channelId={this.props.channelId}
                        shortCourseId={this.props.shortCourse.id}
                        courseHash={this.props.shortCourse.hash}
                        onPreviewActivity={this.props.onPreviewActivity}
                        openConfirmModal={this.openChildModal}
                        reviewMode={this.props.reviewMode}
                        commentProps={commentProps}
                        activityTypes={this.props.shortCourse.activity_types}
                        />
                </div>
                : 
                <div className="short-course-node-editor">
                    <ShortCourseSettingsEditor projects={this.props.projects} activities={this.props.activities} templates={this.props.templates} 
                        channelId={this.props.channelId}
                        badgeTemplates={this.props.badgeTemplates}
                        courseHash={this.props.shortCourse.hash}
                        onPreviewActivity={this.props.onPreviewActivity}
                        openConfirmModal={this.openChildModal}
                        onEditCoachText={this.editRichText}
                        reviewMode={this.props.reviewMode}
                        commentProps={commentProps}
                        editingComment={editingComment}
                        app={this.app}
                        activityTypes={this.props.shortCourse.activity_types}
                        />
                </div>
                }
                {this.props.editedDoc ? <ContentUpdater doc={this.props.editedDoc} activities={this.props.activities} templates={this.props.templates}/> : null}
                {_.map(this.props.errorLines, (txt, i) => {
                    const eo = (typeof txt === 'string') ? { message: txt } : txt;
                    return (
                        <ErrorBox key={i} error={eo} />
                    );
                })}
            </div>
        );
    } // renderShortCourseFlowEditor
    
    canNavigateToLocation=(loc)=>{
        if (!loc) {
            return false;
        }
        const doc = this.props.editedDoc;
        switch(loc.type) {
            case ShortCourseConstants.NAV_TYPES.Node:
            {
                if (typeof loc.id === 'undefined' || loc.id === -1) {
                    return false;
                }
                let node = _.find(doc.nodes,{node_id:loc.id});
                if (!node) {
                    return false;
                }
                return true;
            }
            case ShortCourseConstants.NAV_TYPES.Settings:
                return true;

            case ShortCourseConstants.NAV_TYPES.CoachScript:
            {
                let coachEntry = _.find(doc.client_content.coach_scripts,{id:loc.id});
                if (!coachEntry) {
                    return false;
                }
                if ((typeof loc.action_index === 'number') && (loc.action_index >= 0)) {
                    if (!coachEntry.actions[loc.action_index]) {
                        return false;
                    }
                }
                if (loc.rich_text_id) {
                    let richTextEntry = _.find(doc.client_content.rich_texts,{id:loc.rich_text_id});
                    if (!richTextEntry) {
                        return false;
                    }
                }
                return true;
            }
            case ShortCourseConstants.NAV_TYPES.RichText:
            {
                let richTextEntry = _.find(doc.client_content.rich_texts,{id:loc.id});
                if (!richTextEntry) {
                    return false;
                }
                return true;
            }
        }
        return false;
    } //canNavigateToLocation
    
    getFirstOpenCommentAtNavLoc=(loc)=>{
        if (!this.props.courseCommentInfo) {
            return;
        }
        const comments = this.props.courseCommentInfo.shortCourseComments;
        var c = _.find(comments,function(elem) {
            if (elem.status === 'OPEN') {
                return (_.isEqual(loc,elem.location));
            }
            return false;
        });
        return c;
    }
    
    showCommentsAtLoc=(loc)=>{
        ShortCourseEditorActions.setCurrentNavLoc(loc);
        let comment = this.getFirstOpenCommentAtNavLoc(loc);
        if (comment) {
            ShortCourseEditorActions.setSelectedCommentTopic(comment.id);
            setTimeout(()=>{
                ShortCourseEditorActions.goToLocation(loc);
            },1);
        }
    }
    
    canAddComment=()=>{
        if (this.props.courseCommentInfo) {
            return this.props.courseCommentInfo.permissions.addComment ? true : false;
        }
        return false;
    }
    
    hasOpenComment=(loc)=>{
        var c = this.getFirstOpenCommentAtNavLoc(loc);
        return c ? true : false;
    }
    
    selectedCommentIsInNavLoc=(loc)=>{
        if (!this.props.courseCommentInfo) {
            return false;
        }
        const comments = this.props.courseCommentInfo.shortCourseComments;
        const storeState = ShortCourseEditorStore.getState();
        var selected_comment = storeState.selectedCommentTopicID;
        var c = _.find(comments,{id:selected_comment});
        if (c) {
            if ((typeof loc.id === 'undefined') || (loc.id === '') || (loc.id === -1)) {
                return (loc.type === c.location.type);
            }
            return _.isEqual(loc,c.location);
        }
        return false;
    }
    
    describeCommentLocation=(loc)=>{
        if (!loc) {
            return "Global";
        }
        const doc = this.props.editedDoc;
        switch(loc.type) {
            case ShortCourseConstants.NAV_TYPES.Node:
            {
                if (typeof loc.id === 'undefined' || loc.id === -1) {
                    return "Short Course";
                }
                let node = _.find(doc.nodes,{node_id:loc.id});
                if (!node) {
                    return "nonexistent node (" + loc.id + ")";
                }
                if(node.capstone) {
                    return "Capstone";
                }
                return `Skill Node: ${node.name}`;
            }
            case ShortCourseConstants.NAV_TYPES.Settings:
                return "Settings";
            case ShortCourseConstants.NAV_TYPES.CoachScript:
            {
                let coachEntry = _.find(doc.client_content.coach_scripts,{id:loc.id});
                if (!coachEntry) {
                    return `Coach Entry ${loc.id}: missing/deleted`;
                }
                let locDescription = `Coach Script: ${coachEntry.displayName}`;
                if ((typeof loc.action_index === 'number') && (loc.action_index >= 0)) {
                    locDescription += `, action ${loc.action_index+1}`;
                }
                let richTextEntry = _.find(doc.client_content.rich_texts,{id:loc.rich_text_id});
                if (richTextEntry) {
                    locDescription += `, rich text: ${richTextEntry.displayName}`;
                }
                return locDescription;
            }
            case ShortCourseConstants.NAV_TYPES.RichText:
            {
                let richTextEntry = _.find(doc.client_content.rich_texts,{id:loc.id});
                if (!richTextEntry) {
                    return `Rich Text ${loc.id}: missing/deleted`;
                }
                return `Rich Text: ${richTextEntry.displayName}`;
            }
        }
    }
    
    render() {
        const sidebarBorder = 20;
        let pixelWidth = (this.state.editorPixelWidth - this.state.sidebarCollapsedWidth - 5);
        var editorScrollAreaClasses;
        var editorScrollAreaStyle={
            width: pixelWidth + 'px'
        };
        var sidebarClass = "collapsed-sidebar";
        var sidebarStyle={
            width: this.state.sidebarCollapsedWidth + 'px'
        };
        var maxDragLeft = 0; 
        var maxDragRight = 0; 
        var wantHzRule = false;
        
        if (this.state.expandingSidebarMode !== ESM.Collapsed) {
            editorScrollAreaClasses="editor-scroll-area main-width-expanded-sidebar-1";
            pixelWidth = (this.state.editorPixelWidth - this.state.sidebarExpandedWidth - sidebarBorder);
            editorScrollAreaStyle = {
                width: pixelWidth + 'px'
            };
            sidebarClass = "expanded-sidebar";
            sidebarStyle={
                width: this.state.sidebarExpandedWidth + 'px'
            };
            var minW = Math.round(this.state.editorPixelWidth * 0.1);
            var maxW = Math.round(this.state.editorPixelWidth * 0.5);
            maxDragLeft = this.state.sidebarExpandedWidth - minW;
            maxDragRight = maxW - this.state.sidebarExpandedWidth;
            wantHzRule = true;
        }
        else {
            editorScrollAreaClasses="editor-scroll-area main-width-collapsed-sidebars";
        }

        // editor sidebar (for comments, validation, search etc)
        var esb_content = null; // expandable sidebar content
        var sidebarTitle = '';
        
        switch(this.state.expandingSidebarMode) {
            case ESM.Comments:
                esb_content = (
                    <div className="esb-section">
                        <ReviewCommentEditor ref={(child) => { this._commentEditor = child; }} 
                            commentInfo={this.props.courseCommentInfo} 
                            userHash={this.state.userHash}
                            describeCommentLocation={this.describeCommentLocation}
                            canNavigateToLocation={this.canNavigateToLocation}
                            refreshComments={this.props.refreshComments}
                            commentAction={this.props.commentAction}
                            openConfirmDialog={(text,message,buttonText,confirmHandler)=>{
                                this.openChildModal({text,message,buttonText,confirmHandler,
                                    cancelHandler: this.cancelChildModal,
                                    closeHandler: this.closeChildModal,
                                })
                            }}
                            />
                    </div>
                );
                sidebarTitle = 'Comments';
                break;
//            case ESM.Help:
//                esb_content = (
//                    <div className="esb-section">
//                        <HelpSidebar/>
//                    </div>
//                );
//                sidebarTitle = 'Help';
//                break;
            case ESM.Validation:
                esb_content = (
                    <div className="esb-section">
                        <ValidationSidebar data={this.getDataForValidation()} 
                            commentInfo={this.props.courseCommentInfo}
                            refreshComments={this.props.refreshComments}
                        />
                    </div>
                );
                sidebarTitle = 'Validation';
                break;
            case ESM.Search:
                esb_content = (
                    <div className="esb-section">
                        <SearchSidebar/>
                    </div>
                );
                sidebarTitle = 'Search';
                break;
        }
        
        let editingComment = false;
        if (this._commentEditor) {
            editingComment = this._commentEditor.isEditingComment();
        }
        const commentProps = this.getCommentProps();
        
        return (
            <div className="editor-app">
                <div className="editor-content-area" ref="contentarea">
                    <div className={editorScrollAreaClasses} style={editorScrollAreaStyle} ref="nodeScrollArea">
                        {this.renderShortCourseFlowEditor(pixelWidth)}
                    </div>
                    <div className={sidebarClass} style={sidebarStyle}>
                        {this.state.expandingSidebarMode === ESM.Collapsed ? null : 
                        <Draggable 
                            key={this.state.sidebarKey} 
                            axis="x"
                            // handle=".handle"
                            // defaultPosition={{x: 0, y: 0}}
                            // position={null}
                            // grid={[25, 25]}
                            bounds={{
                                left: maxDragLeft, 
                                top: 0, 
                                right: maxDragRight, 
                                bottom: 0
                            }}
                            //onStart={this.handleSideDividerDragStart}
                            onDrag={this.handleSideDividerDrag}
                            onStop={this.handleSideDividerDragStop}
                            >
                            <span className="side-divider-bar"/>
                        </Draggable>
                        }
                        <div className="sidebar-header">
                            {this.state.enableCommentSidebar ?
                            <span role="button" className={"glyphicon glyphicon-comment" + (this.state.expandingSidebarMode !== ESM.Comments ? " fr":"")}
                                onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('show-comment-sidebar-button',evt)}*/}
                                onClick={this.toggleCommentSidebar} 
                                title={(this.state.expandingSidebarMode === ESM.Comments) ? "hide comments" : "show comments"}>
                                <span className="upper-number" title="open comments assigned to you">{this.state.userCommentCount}</span>
                                <span className="lower-number" title="all open comments">{this.state.allCommentCount}</span>
                            </span> : null }
                            {/*<span role="button" className={"glyphicon glyphicon-question-sign" + (this.state.expandingSidebarMode !== ESM.Help ? " fr":"")} 
                                onMouseOver={(evt)=>{Actions.onMouseOverHelpHandler('show-help-sidebar-button',evt)}}
                                onClick={this.toggleHelpSidebar} 
                                title={(this.state.expandingSidebarMode === ESM.Help) ? "collapse help" : "show help"}>
                            </span>*/}
                            <span role="button" className={"glyphicon glyphicon-check" + (this.state.expandingSidebarMode !== ESM.Validation ? " fr":"")} 
                                onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('show-validation-sidebar-button',evt)}*/}
                                onClick={this.toggleValidationSidebar} 
                                title={(this.state.expandingSidebarMode === ESM.Validation) ? "collapse validation" : "show validation"}>
                                <span className="upper-number" title="validation errors">{this.state.validationErrorCount}</span>
                                <span className="lower-number" title="validation warnings">{this.state.validationWarningCount}</span>
                            </span>
                            <span role="button" className={"glyphicon glyphicon-search" + (this.state.expandingSidebarMode !== ESM.Search ? " fr":"")} 
                                onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('show-search-sidebar-button',evt)}*/}
                                onClick={this.toggleSearchSidebar} 
                                title={(this.state.expandingSidebarMode === ESM.Search) ? "collapse search" : "show search"}>
                            </span>
                            <span className="sidebar-title">{sidebarTitle}</span>
                        </div>
                        {wantHzRule ? <hr/> : null}
                        {esb_content}
                    </div>
                    {(this.state.modalState['child']) &&
                        <ConfirmModal
                            {...this.state.childModalParams} 
                            confirmHandler={this.confirmChildModal}
                            cancelHandler={this.cancelChildModal}
                            closeHandler={this.closeChildModal}
                        />
                    }
                    { this.state.modalState.rich_text_editor ?
                        <RichTextEditor app={this.app}
                            modalExtraClass={editingComment ? "modal-with-sidebar" : "" }
                            src={ this.doGetRichText() } 
                            onApply={this.doApplyRichTextChanges}
                            onCancel={ () => {this.closeRichTextEditor()} }
                            title={this.state.modalState.rich_text_editor_title}
                            onTitleChange={this.state.modalState.rich_text_editor_title_editable ? this.onRichTextTitleChange : null}
                            minimal={false}
                            entryId={`${this.props.shortCourse.hash}-${this.getRichTextId()}`}
                            noTables noLayoutElements noBackgroundControl noMarginControls
                            placeholder="Enter Content Here..."
                            customTextSnippets={this.doGetRichTextSnippets()}
                            customTextSnippetPrompt="Insert variable..."
                        >
                            <div className="rich-text-comment-wrapper">
                                <GotoCommentIcon {...commentProps} navLoc={this.getRichTextNavLoc()} />
                            </div>
                        </RichTextEditor>
                    : null }
                    
                </div>
            </div>
        )
    }
}

EditShortCourse.propTypes = EditShortCoursePropTypes;
EditShortCourse.defaultProps = EditShortCourseDefaultProps;

export default EditShortCourse;